import { render, staticRenderFns } from "./Bins.vue?vue&type=template&id=6cdc7e06&"
import script from "./Bins.vue?vue&type=script&lang=js&"
export * from "./Bins.vue?vue&type=script&lang=js&"
import style0 from "./Bins.vue?vue&type=style&index=0&id=6cdc7e06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports